import { apiDaInscricao } from "../../../servicos/axios";

export type Cidade = {
  id: number;
  nome: string;
  cepPadrao?: string;
};

export const buscarCidades = async (): Promise<Cidade[]> => {
  const response = await apiDaInscricao().get(
    "/Cidades/ListarCidadesPorEstado"
  );
  return response.data;
};
